<template>
  <div>
    <v-toolbar dark flat color="grey-lighten">
      <v-toolbar-title>Gestión de representantes</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent>
        <v-btn
          slot="activator"
          color="primary"
          dark
          class="mb-2"
          @click="initializeRelacionPersonas"
        >Nuevo</v-btn>

        <v-card>
          <v-card-title class="headline info">
            <span>{{ formTitle }}</span>
          </v-card-title>

          <v-form v-model="formularioRepresentanteValido">
            <v-card-text>
              <section class="my-5 section-preview">
                <h2
                  class="h1-responsive text-center font-weight-bold text-uppercase my-5"
                >Información del representante</h2>

                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.numeroDocumento"
                        :rules="numeroRules"
                        label="Número documento"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.primer_nombre"
                        :rules="soloTextoRules"
                        label="Primer nombre"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="editedItem.segundo_nombre" label="Segundo nombre"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.primer_apellido"
                        :rules="soloTextoRules"
                        label="Primer apellido"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="editedItem.segundo_apellido" label="Segundo apellido"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.email"
                        :rules="emailRules"
                        label="Correo electrónico"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </section>

              <section class="my-5 section-preview">
                <h2
                  class="h1-responsive text-center font-weight-bold text-uppercase my-5"
                >Listado de personas relacionadas</h2>

                <v-toolbar dark flat color="grey-lighten">
                  <v-toolbar-title>Gestión de personas</v-toolbar-title>
                  <v-divider class="mx-2" inset vertical></v-divider>

                  <v-spacer></v-spacer>

                  <v-dialog v-model="dialog" persistent max-width="700px">
                    <v-btn slot="activator" color="primary" dark class="mb-2">Asociar persona</v-btn>

                    <!-- <v-card>
                      <v-card-title class="headline info">
                        <span>{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItem.numeroDocumento"
                                label="Número documento"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItem.primer_nombre"
                                label="Primer nombre"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItem.segundo_nombre"
                                label="Segundo nombre"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItem.primer_apellido"
                                label="Primer apellido"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItem.segundo_apellido"
                                label="Segundo apellido"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field v-model="editedItem.email" label="Correo electrónico"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                              <h3>Bloques</h3>
                              <v-select
                                v-model="editedItem.bloques"
                                :items="bloques"
                                label="Bloques"
                                item-text="nombre"
                                return-object
                                multiple
                                chips
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" @click="close">Cancelar</v-btn>
                        <v-btn color="green darken-1" @click="save">Guardar</v-btn>
                      </v-card-actions>
                    </v-card> -->
                  </v-dialog>
                </v-toolbar>

                <v-card-title>
                  <v-text-field
                    v-model="searchRelacionPersonas"
                    append-icon="search"
                    label="Buscar..."
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>

                <v-data-table
                  :headers="headersRelacionPersonas"
                  :items="tableDataRelacionPersonas"
                  :search="searchRelacionPersonas"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.numeroDocumento }}</td>
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs">{{ props.item.email }}</td>
                    <td class="text-xs text-center">
                      <div v-for="bloque in props.item.bloques" :key="bloque.id">
                        <!-- @click="obtenerResultadoTrasladoRelacionPersonas(props.item.id, bloque.id)" -->
                        <v-chip
                          class="ma-2"
                          :color="bloque.tieneRelacionTraslado === 1 ? 'green accent-4' : 'red accent-4'"
                          text-color="white"
                        >{{ bloque.nombre }}</v-chip>
                      </div>
                    </td>
                    <td>
                      <!-- <v-icon small class="mr-2" @click="editItemRelacionPersonas(props.item)">edit</v-icon> -->
                      <!-- <v-icon small @click="deleteItemRelacionPersonas(props.item)">delete</v-icon> -->
                    </td>
                  </template>

                  <template slot="no-data">
                    <v-btn color="primary" @click="initializeRelacionPersonas">Recargar</v-btn>
                  </template>
                </v-data-table>
              </section>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" @click="close">Cancelar</v-btn>
              <v-btn
                color="green darken-1"
                @click="save"
                v-if="formularioRepresentanteValido"
              >Guardar</v-btn>
              <v-btn color="gray darken-1" disabled v-else>Guardar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-dialog v-model="dialogEliminar" persistent max-width="290">
      <v-card>
        <v-card-title class="headline info">Eliminar registro</v-card-title>

        <v-card-text>¿Está seguro de eliminar el registro?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" @click="dialogEliminar = false">Cancelar</v-btn>

          <v-btn color="green darken-1" @click="confirmDeleteItem">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogErrorEliminar" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline info">Eliminar registro</v-card-title>

        <v-card-text>No se puede eliminar este registro porque tiene información relacionada con bloques y/o representantes.</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" @click="dialogErrorEliminar = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="tableData" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.numeroDocumento }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs">{{ props.item.email }}</td>
        <td class="text-xs text-center">
          <div v-for="persona in props.item.personas" :key="persona.id">
            <!-- @click="obtenerResultadoTraslado(props.item.id, bloque.id)" -->
            <v-chip
              class="ma-2"
              text-color="white"
              :color="persona.tieneRelacionTraslado === 1 ? 'green accent-4' : 'blue accent-4'"
            >{{ persona.name }}</v-chip>
          </div>
        </td>
        <td class="text-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { EventBus } from "../../../EventBus";

export default {
  data: () => ({
    dialog: false,
    dialogEliminar: false,
    dialogErrorEliminar: false,
    formularioRepresentanteValido: true,
    numeroRules: [
      (v) =>
        v >= 0 || "Es un campo numérico obligatorio de mínimo 4 caracteres",
      (v) =>
        /[0-9]{4,}/.test(v) ||
        "Es un campo numérico obligatorio de mínimo 4 caracteres",
    ],
    soloTextoRules: [
      (v) =>
        /[a-zA-z]{2,}/.test(v) ||
        "Es un campo de texto obligatorio de mínimo 4 caracteres",
    ],
    emailRules: [
      (v) =>
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(v) ||
        "Debe digitar un correo electrónico válido",
    ],
    headers: [
      { text: "Número documento", value: "numeroDocumento" },
      { text: "Nombre completo", value: "name" },
      { text: "Correo electrónico", value: "email" },
      { text: "Personas", value: "personas", align: "center", sortable: false },
      { text: "Acciones", value: "name", align: "center", sortable: false },
    ],
    search: "",
    tableData: [],
    editedIndex: -1,
    editedItem: {
      numeroDocumento: "",
      primer_nombre: "",
      segundo_nombre: "",
      primer_apellido: "",
      segundo_apellido: "",
      email: "",
      personas: [],
    },
    defaultItem: {
      numeroDocumento: "",
      primer_nombre: "",
      segundo_nombre: "",
      primer_apellido: "",
      segundo_apellido: "",
      email: "",
      personas: [],
    },
    personas: [],
    headersRelacionPersonas: [
      { text: "Número documento", value: "numeroDocumento" },
      { text: "Nombre completo", value: "name" },
      { text: "Correo electrónico", value: "email" },
      { text: "Bloques", value: "bloques", align: "center", sortable: false },
      { text: "Acciones", value: "name", sortable: false },
    ],
    searchRelacionPersonas: "",
    tableDataRelacionPersonas: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Formulario de creación"
        : "Formulario de edición";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      axios.get("/api/representantes").then((response) => {
        this.tableData = response.data.data;
      });
    },
    initializeRelacionPersonas() {
      axios.get("/api/personas").then((response) => {
        this.tableDataRelacionPersonas = response.data.data;
      });
    },
    obtenerNombreCompleto(representante) {
      let nombreCompleto = representante.primer_nombre;
      nombreCompleto = representante.segundo_nombre
        ? `${nombreCompleto} ${representante.segundo_nombre}`
        : nombreCompleto;
      nombreCompleto = `${nombreCompleto} ${representante.primer_apellido}`;
      nombreCompleto = representante.segundo_apellido
        ? `${nombreCompleto} ${representante.segundo_apellido}`
        : nombreCompleto;
      return nombreCompleto;
    },
    editItem(item) {
      this.initializeRelacionPersonas();
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEliminar = true;
    },
    confirmDeleteItem() {
      axios
        .delete("/api/representantes/" + this.editedItem.id)
        .then((response) => {
          this.tableData.splice(this.editedIndex, 1);
        })
        .catch((error) => {
          this.dialogErrorEliminar = true;
        });
      this.dialogEliminar = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      this.editedItem.name = this.obtenerNombreCompleto(this.editedItem);
      if (this.editedIndex > -1) {
        axios
          .put("/api/representantes/" + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.tableData[this.editedIndex], response.data.data);
            this.close();
          });
      } else {
        axios.post("/api/representantes/", this.editedItem).then((response) => {
          this.tableData.push({
            ...response.data.data,
          });
          this.close();
        });
      }
    },
  },
};
</script>

<style lang="css" scoped>
.section-preview {
  border: 1px solid #e0e0e0;
  padding: 15px;
}
</style>